import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import { NsList } from './customElements';
import { ResponsiveDetails } from './details';
import { Tag } from './tag';

type Tags =
  | GatsbyTypes.WorksIndexQuery['tags']
  | GatsbyTypes.PostsIndexQuery['tags'];
type Props = {
  tags: Tags;
  type: Page;
};
const Wrap = styled(ResponsiveDetails)`
  grid-area: tags;
  justify-self: start;
  position: sticky;
  top: 3rem;
  align-self: start;
  ${media.lessThan('large')`
    position: static;
  `}
`;

const List = styled(NsList)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const Tags = ({ tags, type }: Props) => {
  const sortedTags: Tags['group'] = [...tags.group].sort(
    (first, second) => first.totalCount - second.totalCount,
  );
  return (
    <Wrap summary="All tags">
      <List>
        {sortedTags.map((tag) => (
          <li key={tag.name}>
            <Tag type={type} name={tag.name} count={tag.totalCount}></Tag>
          </li>
        ))}
      </List>
    </Wrap>
  );
};
